var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5959 45.2358L62.8018 58.4387L58.4389 62.8016L45.2361 49.5957C40.3235 53.5338 34.2132 55.6757 27.917 55.6667C12.599 55.6667 0.166992 43.2347 0.166992 27.9167C0.166992 12.5987 12.599 0.166748 27.917 0.166748C43.235 0.166748 55.667 12.5987 55.667 27.9167C55.6759 34.2129 53.534 40.3233 49.5959 45.2358ZM43.4107 42.948C47.3238 38.9239 49.5092 33.5297 49.5003 27.9167C49.5003 15.9904 39.8402 6.33341 27.917 6.33341C15.9907 6.33341 6.33366 15.9904 6.33366 27.9167C6.33366 39.84 15.9907 49.5001 27.917 49.5001C33.53 49.5089 38.9241 47.3236 42.9482 43.4105L43.4107 42.948Z",
    fill: "#18223D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearch);
export default __webpack_public_path__ + "static/media/ic_search.707c3206e1226ea4d8cf6132d13136a2.svg";
export { ForwardRef as ReactComponent };